import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { AccountService } from '../../guard/account/account.service';
import { AuthService } from '../../services/service';
import { HeaderMenuItem, headerMenuFromUrl, headerMenuHidden } from './header-menu';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  constructor(private router: Router, private accountService: AccountService, private apiService: AuthService) {}
  activeMenu: HeaderMenuItem = 'questions';
  isVisible = false;
  isFirstLogin = false;
  fullName = '';

  ngOnInit(): void {
    const name = sessionStorage.getItem('full_name');
    if (name) {
      this.fullName = name;
    }
    this.applyUrl(this.router.url);
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.applyUrl(event.urlAfterRedirects || event.url);
      }
    });
  }

  logOut(): void {
    localStorage.removeItem('token');
    sessionStorage.clear();
    this.router.navigate(['/login']);
  }

  close(): void {
    this.isVisible = false;
  }

  open(): void {
    this.isVisible = true;
  }

  private applyUrl(url: string): void {
    this.isFirstLogin = headerMenuHidden(url);
    this.activeMenu = headerMenuFromUrl(url);
  }
}
